<template>
    <div  class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>
        <div v-if="verifyUsername" class="flex flex-col justify-center absolute left-0 top-[30%] mx-[30%] z-40 bg-white w-[600px] text-lg rounded-lg border-[2px] border-[#0B6014]">
            <div class="pafcpic_header bg-[#006A00] py-3 px-6">
                <p class="text-[#ffffff] text-md font-bold">FORGOT PASSWORD</p>
            </div>
            <div class="pafcpic_body py-6 px-6">
                <p class="text-[#3a3939] text-sm ">Please enter your username to search for your account.</p>
                <input type="text" @keyup.enter="$emit('search',username)" class="rounded-md text-[#494949] border-[#cccccc] py-3 px-5 border w-full text-sm outline-[#0B6014] mt-1" placeholder="Enter your username" v-model="username">
                <div v-if="error.length > 0" class="ERROR bg-[#5313134f] py-3 text-[#881818c9] px-5 font-semibold border border-[#88181825] rounded-lg mt-3"><p class="text-sm text">{{ error }}</p>
                </div>
            </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-[#ffffff] bg-[#006A00] py-1.5 px-7 rounded-md" @click="$emit('search',username)">SEARCH</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" @click="$emit('cancel')">CANCEL</button>
            </div>
        </div>

        <div v-if="ForgotPassword" class="flex flex-col justify-center absolute left-0 top-[30%] mx-[30%] z-40 bg-white w-[600px] text-lg rounded-lg border-[2px] border-[#0B6014]">
            <div class="pafcpic_header bg-[#006A00] py-3 px-6">
                <p class="text-[#ffffff] text-md font-bold">FORGOT PASSWORD</p>
            </div>
            <div class="pafcpic_body py-6 px-6">
                <p class="text-[#3a3939] text-sm pb-3">A one-time password (OTP) has been sent to your email address. Please check your inbox.</p>
                <div class="grid grid-cols-3 gap-3">
                    <input type="number" class="col-span-2 rounded-md text-[#494949] border-[#cccccc] py-2.5 px-5 border w-full text-sm outline-[#0B6014] mt-1" placeholder="OTP" v-model="inputOTP" @input="otpValidation">
                    <button class=" col-span-1 text-xs bg-[#CCAF12] rounded-lg text-[#fff]" :disabled="isButtonDisabled" @click="$emit('resendOtp',username)">RESEND OTP {{ countdownMessage }}</button>
                </div>
            
                <div class="grid grid-cols-1 gap-1 mt-3">
                    <!-- <input type="password1" class="col-span-1 rounded-md text-[#494949] border-[#cccccc] py-3 px-5 border w-full text-sm outline-[#0B6014] mt-1" placeholder="Enter your new password" v-model="inputPassword"> -->
                        <input class="col-span-2 rounded-md text-[#494949] border-[#cccccc] py-2.5 px-5 border w-full text-sm outline-[#0B6014] mt-1"
                          type="password"
                          id="password"
                          v-model="password"
                          @input="valPassword()"
                          placeholder="Enter your password"
                        />
                        <div class="validation-results px-3">
                          <p :class="{'valid': isLengthValid, 'invalid': !isLengthValid}">
                            ✓ Minimum length: 8 characters
                          </p>
                          <p :class="{'valid': hasUppercase, 'invalid': !hasUppercase}">
                            ✓ Contains uppercase letter
                          </p>
                          <p :class="{'valid': hasLowercase, 'invalid': !hasLowercase}">
                            ✓ Contains lowercase letter
                          </p>
                          <p :class="{'valid': hasNumber, 'invalid': !hasNumber}">
                            ✓ Contains a number
                          </p>
                          <p :class="{'valid': hasSpecialChar, 'invalid': !hasSpecialChar}">
                            ✓ Contains special character
                          </p>
                        </div>
                   
          
                    <div class="flex col-span-2 gap-5">
                        <button class=" w-[50%] text-xs bg-[#11760ae5] rounded-lg text-[#fff] py-3 px-5 mt-4" @click="$emit('cancel')">CANCEL</button>
                        <button class=" w-[50%] text-xs bg-[#12760A] rounded-lg text-[#fff] py-3 px-5 mt-4 " @click="changePass(inputOTP,password)">CHANGE PASSWORD</button>
                    </div>
                   
                </div>
                <div v-if="error.length > 0" class="ERROR bg-[#5313134f] py-3 text-[#881818c9] px-5 font-semibold border border-[#88181825] rounded-lg mt-3"><p class="text-sm text">{{ error }} </p>
                </div>
                <div v-if="errorpassword != null" class="ERROR bg-[#5313134f] py-3 text-[#881818c9] px-5 font-semibold border border-[#88181825] rounded-lg mt-3"><p class="text-sm text">{{ errorpassword }} </p>
                </div>
            </div>
        </div>

</template>

<script>

import { defineComponent } from "vue"

export default defineComponent({
components: {
    
},
data() {
    return {
        score:null,
        username:'',
        inputOTP:'',
        inputPassword:'',
        countdown: 60,
        isButtonDisabled: true,
        countdownMessage: 60,
        isLengthValid: false,
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSpecialChar: false,
        isValidPassword: false,
        password:"",
        errorpassword: null,
        
    }
},
props: {
    Data: {
        type: Object,
        default: null,
    },
    Approval:{
        type : Boolean,
        default: false,
    },
    error:{
        type : String
    },
    email:{
        type : String
    },
    otp:{
        type : String
    },
    verifyUsername:{
        type    : Boolean,
        default : false,
    },
    ForgotPassword:{
        type    : Boolean,
        default : false
    }   
},
mounted(){
 
},
methods:{
    changePass(inputOTP,password){
        if(this.isLengthValid && this.hasUppercase && this.hasLowercase  && this.hasNumber && this.hasSpecialChar ){
            this.$emit('changePassword',inputOTP,password)
        }
        else{
            this.errorpassword = "Your password does not meet the required criteria."
        }
      
    },
    valPassword() {
        // Reset the flags before each validation run
        this.isLengthValid    = false;
        this.hasUppercase     = false;
        this.hasLowercase     = false;
        this.hasNumber        = false;
        this.hasSpecialChar   = false;

        const lengthPattern = /.{8,}/;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const numberPattern = /\d/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const trimmedPassword = this.password.trim();


      this.isLengthValid = lengthPattern.test(trimmedPassword);
      this.hasUppercase = uppercasePattern.test(trimmedPassword);
      this.hasLowercase = lowercasePattern.test(trimmedPassword);
      this.hasNumber = numberPattern.test(trimmedPassword);
      this.hasSpecialChar = specialCharPattern.test(trimmedPassword);

    },
    startTimer() {
      let that = this
      const interval = setInterval(() => {
        that.countdownMessage = that.countdown;
        that.countdown--;
        if (that.countdown <= 0) {
          clearInterval(interval);
            that.countdownMessage = null;
            that.isButtonDisabled = false;
            that.countdown = 60;
            }
          }, 1000);
    },
    otpValidation(){
        if(String(this.inputOTP).length >= 6){
            this.inputOTP = String(this.inputOTP).slice(0,6)
        }}   
    },
})

</script>

<style scoped>
.password-validation {
  max-width: 400px;
  margin: 20px;
}



.validation-results p {

  font-size: 13px;
  color: #d9534f; /* Default red for invalid conditions */
}

.validation-results p.valid {
  color: #07c410; /* Green color for valid conditions */
}

.validation-results p.invalid {
  color: #d9534f; /* Red color for invalid conditions */
}

.error-message {
  color: red;


}
</style>